import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Typography, Paper, Button } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import setUserRealm from 'redux/actions/userRealm';
import setFilter from 'redux/actions/setFilter';
import { get, isEqual } from 'global/lib/lodash';
import useStyles from './styles';
import { LoadingTruck, NopeIcon, ConfusedIcon, DoneIcon } from 'global/components/LoadingIcons';
import RefreshIcon from '@material-ui/icons/Refresh';
import PinDropIcon from '@material-ui/icons/PinDrop';
import { FILTERDEFAULTS } from '../filterchips/definitions';

export default (props) => {
  const { loading } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const location = useLocation();
  const page = location.pathname.includes('/tasks/list/')
    ? 'tasks.realm'
    : location.pathname.includes('/tasks/age')
    ? 'tasks.age'
    : location.pathname === '/tasks/list'
    ? 'tasks.list'
    : location.pathname.includes('/reports/list')
    ? 'reports.list'
    : location.pathname.includes('/reports/data')
    ? 'reports.data'
    : location.pathname.includes('/reports/photo')
    ? 'reports.photo'
    : location.pathname.includes('/users/courses')
    ? 'users.courses'
    : location.pathname.includes('/users')
    ? 'users.manage'
    : location.pathname.includes('/highlights')
    ? 'highlights'
    : location.pathname.includes('/library/')
    ? 'library.standards'
    : location.pathname === '/library'
    ? 'library.editions'
    : '';
  const [type, setType] = useState(page ? page.split('.')[0] : location.pathname.split('/')[1]);
  const [primary, setPrimary] = useState('Nothing to see here');
  const [secondary, setSecondary] = useState('');
  const [buttons, setButtons] = useState([]);
  const [icon, setIcon] = useState(0);

  const filterVals = useSelector((state) => get(state, `filter.${page}`, false));
  const filterDefaults = get(FILTERDEFAULTS, page, []);
  const filterChanged = Object.keys(filterVals).filter((key) => key !== 'ownership' && !isEqual(get(filterDefaults, key), filterVals[key]));
  const realm = useSelector((state) => get(state, 'auth.realm', false));

  const handleRealmReset = (changed) => {
    dispatch(setUserRealm(null));
  };

  const handleFilterReset = () => {
    dispatch(setFilter(page ? page.split('.')[0] : location.pathname.split('/')[1], page.includes('.') ? page.split('.')[1] : location.pathname.split('/')[2], filterDefaults));
  };

  useEffect(() => {
    if (page === 'reports.photo') {
      setType('photos');
    } else if (type === 'reports') {
      setType('assessments');
    } else if (page === 'library.standards') {
      setType('documents');
    } else if (page === 'library.editions') {
      setType('editions');
    } else if (page === 'tasks.realm') {
      setType('PDFs');
    } else if (page === 'tasks.list') {
      setType('locations with tasks');
    }
  }, [page]);

  useEffect(() => {
    var buttonsTemp = [];
    if (loading) {
      setIcon(0);
      setPrimary('Working');
      setSecondary('');
      setButtons([]);
    } else {
      setIcon(1);
      if (realm !== null) {
        setSecondary('Perhaps try changing your filters or location');
        buttonsTemp.push({ text: 'Reset Location', icon: <PinDropIcon />, onClick: handleRealmReset });
      }
      if (type !== '') {
        setPrimary(`No ${type} here`);
        if (page === 'tasks.age') {
          setIcon(2);
          if (realm !== null) {
            if (get(filterVals, 'ownership') === 'my') {
              setSecondary(
                <>
                  You have no open tasks for <em>{get(realm, 'name')}</em>
                </>
              );
            } else {
              setSecondary(
                <>
                  The {get(realm, 'tier')} <em>{get(realm, 'name')}</em> has no open tasks
                </>
              );
            }
          }
        } else if (page === 'users.manage') {
          setSecondary(
            <>
              Use the<strong> + Create </strong>tab to make some
            </>
          );
        } else if (page === 'users.courses') {
          setPrimary('No Courses here');
          setSecondary('Perhaps try changing your filters or location');
        }
      }

      if (filterVals && filterVals.searchstring) {
        setPrimary(`Couldn't find it.`);
        setSecondary(`We couldn't find any${type !== '' ? ` ${type}` : 'thing'} like "${get(filterVals, 'searchstring')}" ${get(realm, 'name') ? ' in ' + get(realm, 'name') : ''}`);
        setIcon(3);
      }

      if (filterChanged.length > 0) {
        buttonsTemp.push({ text: 'Reset Filters', icon: <RefreshIcon />, onClick: handleFilterReset });
      }

      setButtons(buttonsTemp);
    }
  }, [type, filterVals, realm, loading]);

  const renderIcon = () => {
    if (icon === 0) {
      return <LoadingTruck fontSize="large" color="primary" classes={{ fontSizeLarge: classes.iconLarge }} />;
    }
    if (icon === 2) {
      return <DoneIcon fontSize="large" color="primary" classes={{ fontSizeLarge: classes.iconLarge }} />;
    }
    if (icon === 3) {
      return <ConfusedIcon fontSize="large" color="primary" classes={{ fontSizeLarge: classes.iconLarge }} />;
    }
    return <NopeIcon fontSize="large" color="primary" classes={{ fontSizeLarge: classes.iconLarge }} />;
  };

  return (
    <div className={classes.container}>
      <Paper className={classes.paper}>
        {renderIcon()}
        <Typography color="primary" variant="h4">
          {get(props, 'noDataText', primary)}
        </Typography>
        <Typography color="primary" variant="body1">
          {secondary}
        </Typography>
        {buttons.map((button) => (
          <Button className={classes.button} color="primary" variant="contained" size="small" onClick={button.onClick} startIcon={button.icon}>
            {button.text}
          </Button>
        ))}
      </Paper>
    </div>
  );
};
